import { MoreHoriz } from '@mui/icons-material'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material'
import { TraceKey } from '@ulysses-inc/harami_api_client'
import { FC, MouseEvent, useCallback, useState } from 'react'
import { gray } from 'src/features/muikds/kdsColors'
import { DeleteConfirmDialog } from '../../DeleteConfirmDialog'

const useMenu = () => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null)

  const openMenu = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    setMenuAnchorEl(event.currentTarget)
  }, [])

  const closeMenu = useCallback(() => {
    setMenuAnchorEl(null)
  }, [])

  const handleMenuClose = useCallback((event: MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setMenuAnchorEl(null)
  }, [])

  return {
    menuAnchorEl,
    openMenu,
    closeMenu,
    handleMenuClose,
  } as const
}

type Props = {
  traceKey: TraceKey
}

export const MenuButton: FC<Props> = ({ traceKey }) => {
  const { menuAnchorEl, openMenu, closeMenu, handleMenuClose } = useMenu()
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)

  const handleDeleteClick = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      event.stopPropagation()
      closeMenu()
      setDeleteDialogOpen(true)
    },
    [closeMenu],
  )

  const handleDeleteDialogClose = useCallback(() => {
    setDeleteDialogOpen(false)
  }, [])

  return (
    <>
      <IconButton
        size="small"
        onClick={openMenu}
        aria-label={`検索キーメニューを開く`}
      >
        <MoreHoriz sx={{ color: gray[9] }} />
      </IconButton>
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleDeleteClick} sx={{ color: 'error.main' }}>
          <ListItemIcon>
            <DeleteOutlinedIcon sx={{ color: 'error.main' }} />
          </ListItemIcon>
          <ListItemText>削除</ListItemText>
        </MenuItem>
      </Menu>
      <DeleteConfirmDialog
        open={deleteDialogOpen}
        traceKey={traceKey}
        onClose={handleDeleteDialogClose}
      />
    </>
  )
}
